import * as React from 'react';

import { ChevronLeft, ChevronRight } from '@volkswagen-onehub/icons-core';

import { TextWrapper } from './text-wrapper';

import { AnimationWrapper } from './animation.wrapper';

export const ArrowLeft: React.FC = () => {
	return (
		<AnimationWrapper isInverted>
			<TextWrapper>
				<ChevronLeft aria-hidden />
			</TextWrapper>
		</AnimationWrapper>
	);
};

export const ArrowRight: React.FC = () => {
	return (
		<AnimationWrapper>
			<TextWrapper>
				<ChevronRight aria-hidden />
			</TextWrapper>
		</AnimationWrapper>
	);
};
